import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { pathKey } from '../utils'

const document = graphql(`
  mutation BrandListPage_CreateBrand(
    $brandGroupId: Int!
    $name: String!
    $brandNumber: Int!
  ) {
    createBrand(
      brandGroupId: $brandGroupId
      name: $name
      number: $brandNumber
    ) {
      id
      name
      number
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useCreateBrandMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Omit<Variables, 'brandGroupId'>, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { brandGroupId } = usePathParams(pathKey)

  return useMutation({
    mutationFn: (data) =>
      graphQLRequest({
        document,
        variables: { brandGroupId: Number(brandGroupId), ...data },
      }),
    ...options,
  })
}
